import React, { useState, useEffect, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Button, TextField } from "@packages/ui";
import SnackBar from "../../layouts/SnackBar";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Slide,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Alert from '@material-ui/lab/Alert';
import _ from "lodash";
import moment from "moment";

import * as checkinActions from "src/actions/checkinActions";
import { REGIONS, COUNTRY } from "../../utils/constants";
import getBrandFromUrl from "src/utils/getBrandFromUrl";
import getDemoFromUrl from "src/utils/getDemoFromUrl";
import { enableInternationalOcrFlow } from "../../env";
import { isMobile } from "react-device-detect";


const AdditionalDriverCheckinLoginForm = (props) => {
  const dispatch = useDispatch();
  // const [bookingNumber, setBookingNumber] = useState("B04NP9");
  // const [bookingNumber, setBookingNumber] = useState("B04Q4H");
  // const [lastName, setSurname] = useState("TRASMONTE");
  // const [licno, setLicno] = useState("DU1234567890");
  const [dialogBox, setDialogBoxOpen] = useState(false);
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  const checkin = useSelector((state) => state.checkin);
  const brand = getBrandFromUrl();
  const isDemo = getDemoFromUrl();


  // const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [isIntlLic, setIsIntlLic] = useState(false);


  let DNR;
  let dlExpired;

  if (_.has(checkin, "customer.DNR")) {
    DNR = checkin?.customer?.DNR;
  }

  if (_.has(checkin, "customer.LatestCustomer.DrivingLicence")) {
    const dlExpiredDate = checkin.customer.LatestCustomer.DrivingLicence.ExpiryDate;
    dlExpired = Date.parse(dlExpiredDate) < Date.now();
  }



  useEffect(() => {
    dispatch(checkinActions.additionalDriverAuth({ bookingNumber: props.resNo, isAdditionalDriver: true }));
  }, []);

  useEffect(() => {
    dispatch(checkinActions.setCheckinDemo({ isDemo: isDemo }));
  }, []);

  useEffect(() => {
    if (DNR == true) {
      setDialogBoxOpen(true);
    } else if (checkin.auth.token == "" && _.has(checkin, "resNo")) {
      window.location.replace(isDemo ? "/additional-driver-checkin/login" : "/additional-driver-checkin/login");
      setDialogBoxOpen(false);
    }
  }, [DNR]);

  useEffect(() => {
    if (
      checkin.auth.success &&
      moment().isBefore(moment.unix(checkin.auth.expires)) &&

      DNR == false
    ) {

      if (isDemo) {
        dispatch(checkinActions.setRequireReVerifyCC({ requireReVerifyCC: true }));
        dispatch(checkinActions.setRequireReVerifyID({ requireReVerifyID: true }));
        dispatch(checkinActions.resetVerifyStatus());
        navigate(`/checkin-demo/privacy/${brand.toLowerCase()}`, { replace: true });

      } else if (checkin.customer.LatestCustomer == null || dlExpired || !checkin.idVerification?.Verified) {
        navigate(`/additional-driver-checkin/privacy/${brand.toLowerCase()}`, { replace: true });

      } else if (checkin.hasValidResult) {
        navigate(`/additional-driver-checkin/complete`, { replace: true });
      }
      else {
        navigate(`/additional-driver-checkin/checkin-form`, { replace: true });
      }

      // navigate(checkin.customer.LatestCustomer == null || dlExpired ? "/checkin/privacy/hertz" : "/checkin/checkin-form", { replace: true });
    } else if (moment() < moment(checkin.auth.expires)) {
      // can't online checkin because it's past the day to pick it up
      // TODO: dispatch error that you can't online checkin past pick up date
    } else if (
      checkin.success &&
      moment() < moment(checkin.auth.expires) &&
      _.isEmpty(checkin.reservation)
    ) {
      // error: reservation returned empty
      // TODO: post error that something has gone wrong with online checkin
    }
  }, [checkin.customer]);


  const validationSchema = Yup.object().shape({
    bookingNumber: Yup.string()
      .required("Required")
      .test("bookingNumber", "Booking Number is invalid", function (bkNumber) {
        const bookingLength = bkNumber.trim().length;
        const islength =
          bookingLength == 6
            ? true
            : bookingLength == 10
              ? true
              : bookingLength == 11
                ? true
                : false;
        return islength;
      }),
    licNo: Yup.string()
      .required("Required")
      .min(4, "Driving Licence must be more than 3 characters")
      .matches(/^[a-zA-Z0-9-]*$/, "Licence Number should only use Letters, Numbers, Hyphen")
      .max(20, "Driving Licence should not have more than 20 characters")
  });

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      bookingNumber: props.resNo ? props.resNo : "",
      licNo: "",
      regionOfIssue: "",

    },
  });

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const Countries = _.sortBy(REGIONS, ["label"]);

  const options = Countries.map((option) => {
    const countryFirstLetter = option.country[0].toLocaleUpperCase();
    return {
      countryFirstLetter: countryFirstLetter,
      ...option,
    };
  });

  const handleClose = () => {
    dispatch(checkinActions.logout());
    // Token empty set false
    setDialogBoxOpen(false);
  };

  const onSubmit = (data) => {
    const bookingNumber = data.bookingNumber.trim().toUpperCase();
    const licNo = data.licNo.trim();
    const licCountry = data.regionOfIssue;

    dispatch(
      checkinActions.searchCustomer({
        licNo: licNo,
        country: licCountry,
        resNo: bookingNumber,
        token: checkin.auth.token,
        isAdditionalDriver: checkin.isAdditionalDriver,
      })
    );

    dispatch(checkinActions.getOcrLabsOutage({ token: checkin.auth.token }));
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Fragment>
          <Controller
            control={control}
            name="bookingNumber"
            render={({ field: { onChange, value, name, ref } }) => (
              <TextField
                fullWidth
                label="Booking Number"
                id="bookingNumber"
                // disabled={value.length == 6}
                value={value}
                onChange={onChange}
                error={errors.bookingNumber ? true : false}
                helperText={errors.bookingNumber ? errors.bookingNumber.message : null}
              />
            )}
          />
          <Controller
            control={control}
            name="licNo"
            render={({ field: { onChange, value } }) => (
              <TextField
                fullWidth
                label="Drivers Licence Number"
                value={value}
                onChange={onChange}
                error={errors.licNo ? true : false}
                helperText={errors.licNo ? errors.licNo.message : null}
              />
            )}
          />
          <Controller
            control={control}
            name="regionOfIssue"
            render={({ field: { onChange, value } }) => (
              <Autocomplete
                label="regionOfIssue"
                disableClearable
                options={options
                  .sort(
                    (a, b) => -b.countryFirstLetter.localeCompare(a.countryFirstLetter)
                  )
                  .sort()}
                groupBy={(option) => option.country}
                getOptionLabel={(option) => option.label}
                defaultValue={options.find((element) => element.label == value)}
                renderOption={(option) => option.label}
                getOptionSelected={(option) => option.country}
                renderInput={(params) => (
                  <TextField
                    inputProps={{
                      autoComplete: "new-password",
                    }}
                    {...params}
                    fullWidth
                    required
                    label="State/Country Of Issue"
                    error={errors.regionOfIssue ? true : false}
                    helperText={
                      errors.regionOfIssue ? errors.regionOfIssue.message : null
                    }
                  />
                )}
                onChange={function (e, data) {
                  onChange(data.country);
                  setIsIntlLic(data.country != "AUSTRALIA")
                }}
              />
            )}
          />
        </Fragment>



        {(isIntlLic && !enableInternationalOcrFlow) && <Alert style={{ marginTop: 15 }} severity="error">Sorry, We are unable to proceed your request with international licence. Please head to the counter on arrival to verify your international licence.</Alert>}


        <Box style={{ marginTop: 15 }}>
          <Button fullWidth loading={checkin.loading} type="submit" title={"Continue"} disabled={(isIntlLic && !enableInternationalOcrFlow) || !isMobile} />
        </Box>

        {!isMobile && <Alert style={{ marginTop: 15 }} severity="error">Sorry, you must use a mobile device to continue checkin!</Alert>}

      </form>

      <SnackBar />

      <Dialog
        open={dialogBox}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {checkin.country == "AU" && brand == "Thrifty"
              ? "Unfortunately your profile has been restricted, please contact our Australian Customer Service Team on 1300 110 196. Please quote your driver’s licence number and reservation number."
              : checkin.country == "AU" && brand == "Dollar"
                ? "Unfortunately your profile has been restricted, please contact our Australian Customer Service Team on 1800 501 967. Please quote your driver’s licence number and reservation number."
                : checkin.country == "AU"
                  ? "Unfortunately your profile has been restricted, please contact our Australian Customer Service Team on 1800 55 00 78. Please quote your driver’s licence number and reservation number."
                  : "Unfortunately your profile has been restricted, please contact our New Zealand Customer Service Team on 0800 921 460. Please quote your driver’s licence number and reservation number."}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button fullWidth onClick={handleClose} loading={checkin.loading} title={"Continue"} />
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AdditionalDriverCheckinLoginForm;
